export interface IBulkDeleteTripsDto {
    tripIds: string[];
}
